import { render, staticRenderFns } from "./DNLHeader.vue?vue&type=template&id=064b590c&scoped=true&"
import script from "./DNLHeader.vue?vue&type=script&lang=js&"
export * from "./DNLHeader.vue?vue&type=script&lang=js&"
import style0 from "./DNLHeader.vue?vue&type=style&index=0&id=064b590c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064b590c",
  null
  
)

export default component.exports